import { PackageService } from "namirasoft-core";
import { ControllerSchema } from "./ControllerSchema";
import { BaseSchema } from "./BaseSchema";
import { ObjectSchema } from "./type/ObjectSchema";

export class ApplicationSchema extends BaseSchema
{
    pkg: PackageService;
    controllers: ControllerSchema[] = [];
    tables: {
        meta: {
            short: string;
        };
        schema: ObjectSchema;
    }[] = [];
    meta: { [name: string]: any } = {};
    constructor(pkg: PackageService)
    {
        super();
        this.pkg = pkg;
    }
    override check(): void
    {
        BaseSchema.checkRepeated("Controller", "endpoint", this.controllers, c => c.tag, c => c.name);
    }
}